import { createTelemetry, type Telemetry } from "@picklebet/telemetry";
import { createSegmentProvider } from "@picklebet/telemetry/providers/segment";
import { createNativeBridgeProvider } from "@picklebet/telemetry/providers/native-bridge";
import { createConsoleProvider } from "@picklebet/telemetry/providers/console";
import { getBridge } from "./bridge";
import { isWebView } from "./display";

let instance: Telemetry | null = null;

function getInstance(): Telemetry {
  if (instance) {
    return instance;
  }

  const providers = [];

  if (process.env.GATSBY_DEBUG_TELEMETRY === "true") {
    providers.push(createConsoleProvider());
  }

  if (typeof window !== "undefined") {
    providers.push(createSegmentProvider(() => window.analytics));
  }

  if (isWebView()) {
    providers.push(createNativeBridgeProvider(getBridge()));
  }

  instance = createTelemetry({
    providers,
    defaultProperties: () => ({
      path:
        typeof window !== "undefined" ? window.location.pathname : undefined,
    }),
  });

  return instance;
}

export const telemetry = new Proxy({} as Telemetry, {
  get(_, prop) {
    return getInstance()[prop as keyof Telemetry];
  },
});
